export enum EnumTipoContato {
    TELEFONE = 0,
    EMAIL = 1
}